import React, { useEffect } from "react";
import useModalStore from "../StatesStore/ModalStore";
import { DashSquare, PlusSquare, X } from "react-bootstrap-icons";
import { message } from "antd";
// import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { UserAuth } from "../Context";
import { useState } from "react";
import { db } from "../FirebaseConfig";
import { saveInviteToDb } from "../lib/saveInviteToDb";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
  collection,
  getDocs,
  deleteDoc,
  onSnapshot,
} from "firebase/firestore";
import { Link } from "react-router-dom";
import {
  Modal,
  Button,
  InputGroup,
  Form,
  Badge,
  CloseButton,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import ProfilePicture from "../UserProfile/ProfilePicture";
import algoliasearch from "algoliasearch";
import CheckStatus from "../lib/checkUserStatus";
import { checkIfEmailExists } from "../lib/checkIfEmailExists";
import useNotification from "../hooks/useNotification";
import { encryptChat } from "./Encryption";
import { saveMessageToDB } from "../Chat/lib.js/saveMsgToDb";
import useChatClient from "../StatesStore/ChatClient";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import { Facebook, WhatsApp, CopyLink } from "./SocialMediaSVGs";
import BottomTray from "../Trays/BottomTray";
import InviteCollaborators from "../Trays/InviteCollaborators";
const client = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_ADMIN_KEY
);
const indexUsers = client.initIndex("users"); // Name of index in Algolia is users

const {
  ShoppingListMail,
  CustomShoppingListMail,
} = require("../EmailSystem/sendEmails");
function InvitePeople({
  selectedShopList,
  listId,
  myName,
  listName,
  listLink,
  componentName,
  BackgroundOnSvg,
  ownerId = null,
  closeOtherDropdown,
  isOpen,
  setIsOpen,
}) {
  const { data, closeModal } = useModalStore();
  const [emailInputValue, setEmailInputValue] = useState("");
  const [emailUsers, setEmailUsers] = useState([]);
  const { user } = UserAuth();
  const [Error, setError] = useState("");
  const regex = /^[a-zA-Z\s]*$/;
  const myEmail = user?.providerData[0].email;
  const text = "Invite Friends";
  const [inviteOption, setInviteOption] = useState("users");
  const { addNotification } = useNotification();
  const [content, setContent] = useState("");
  const [isFriendsDataEmpty, setIsFriendsDataEmpty] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Handle role selection

  const [productImgUrls, setProductImgUrls] = useState([]);
  const [profile, setProfile] = useState("");
  //InviteOnLookflock
  const [friendsData, setFriendsData] = useState([]);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  // let friendCount = 0;
  const [DATA, setDATA] = useState({
    friendId: "",
    displayName: "",
  });

  const [input, setInput] = useState("");
  const [members, setMembers] = useState({});
  const [listMembers, setListMembers] = useState({});
  const client = useChatClient((state) => state.client);
  const [channel, setChannel] = useState(null);
  // console.log("members from invite people", members);
  // console.log("selectedFriends from invite people", selectedFriends);

  useEffect(() => {
    const initializeChannel = async () => {
      if (!client || !listId) return;

      try {
        const channel = client.channel("team", listId);

        setChannel(channel);
      } catch (error) {
        console.error("Error initializing channel:", error);
      }
    };

    initializeChannel();
  }, [client, listId]);
  useEffect(() => {
    const fetchMembers = async () => {
      const membersRef = collection(
        db,
        "users",
        user.uid,
        "shoppingList",
        listName,
        "members"
      );
      const unsubscribe = onSnapshot(membersRef, (membersSnap) => {
        const membersData = {};
        membersSnap.forEach((doc) => {
          membersData[doc.id] = doc.data().role;
        });
        setListMembers(membersData);
      });

      // Cleanup function to unsubscribe from the listener when the component unmounts
      return () => unsubscribe();
    };
    fetchMembers();
  }, [listName]);

  const handleButtonClick = () => {
    // if (selectedShopList.products.length === 0) {
    //   toast.warning("Kindly add some products before sharing!", toastOptions);
    // } else {
    closeOtherDropdown();
    setIsOpen(true);
    // }
  };
  const checkEmails = async (email) => {
    if (email === myEmail) {
      setError("Cannot email yourself");
      return false; // Email is same as user's email
    }
    if (emailUsers.includes(email)) {
      setError("Emails should be unique");
      return false; // Duplicate found
    }
    const emailExists = await checkIfEmailExists(email);
    if (emailExists.exists) {
      const handleLinkClick = () => {
        closeModal(); // Close the modal when the link is clicked
      };

      const userLink = (
        <Link
          to={`/userProfile/${emailExists.userId}`}
          onClick={handleLinkClick}
        >
          {emailExists.firstName}
        </Link>
      );

      // Set the error state with the clickable link
      setError(
        <>
          {email} is already on Lookflock. Add {userLink} and invite them
          directly.
        </>
      );

      return false;
    }
    return true;
  };

  const onEmailFinish = async (values) => {
    if (values.length === 0) {
      if (isValidEmail(emailInputValue)) {
        if (await checkEmails(emailInputValue)) {
          values.push(emailInputValue);
        }
      } else {
        setError("Please enter a valid email");
        return;
      }
    }
    values.forEach(async (email) => {
      // console.log(user, data);
      console.log("listLink", listLink);
      const mailFunction =
        content && content.trim() !== ""
          ? CustomShoppingListMail
          : ShoppingListMail;

      mailFunction(
        myName,
        email,
        listName,
        listLink,
        productImgUrls,
        profile,
        content
      )
        .then(() => {
          message.success({
            content: `Email sent successfully to ${email}`,
            key: "success",
          });
        })
        .catch((error) => {
          message.error(`Error sending email to ${email}`);
          console.error("Error sending email:", error);
        });

      handleClose();
      await saveInviteToDb(
        {
          name: "",
          email,
          type: "email",
        },
        user
      );
    });
  };
  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleKeyDown = async (e) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      const trimmed = emailInputValue.trim().replace(/,$/, "");
      if (
        trimmed &&
        isValidEmail(trimmed) &&
        (await checkEmails(e.target.value))
      ) {
        if (!emailUsers.includes(trimmed)) {
          setEmailUsers([...emailUsers, trimmed]);
        }
        setEmailInputValue("");
      }
    }
  };

  const handleEmailChange = (e) => {
    setError("");
    setEmailInputValue(e.target.value);
  };

  const removeEmail = (removeIndex) => {
    setEmailUsers(emailUsers.filter((_, index) => index !== removeIndex));
  };
  const fetchShoppingListProducts = async () => {
    // console.log("listLink", listLink);
    // console.log("listId", listId);
    const elements = listLink.split("/");
    // console.log("elements", elements);
    // console.log(listLink.split("#")[0]);
    // console.log("elements[5]", elements[5]);
    // console.log(elements[6]);
    const userRef = doc(db, "users", elements[6]);
    const userSnap = await getDoc(userRef);
    const profilePhoto = userSnap?.data()?.photo;
    setProfile(profilePhoto);
    const shopListRef = collection(db, "users", elements[6], "shoppingList");
    const shopList = await getDocs(shopListRef);
    const list = shopList.docs.filter(
      (doc) => doc?.data()?.listId === elements[5]
    );
    // console.log("list123", list[0]?.id);
    const productRef = collection(shopListRef, list[0]?.id, "products");
    const productSnap = await getDocs(productRef);
    const products = productSnap?.docs.map((doc) => doc?.id);
    if (products) {
      const ImgUrls = await Promise.all(
        products?.map(async (product) => {
          const productRef = doc(db, "products", product);
          const productSnap = await getDoc(productRef);
          return { id: productSnap?.id, image: productSnap?.data()?.imageUrl };
        })
      );
      setProductImgUrls(ImgUrls);
      // console.log("ImgUrls", ImgUrls);
    }
  };

  const handleCopyLink = () => {
    const fullLink = listLink.replace(
      "http://localhost:3000",
      "https://lookflock.com"
    );
    navigator.clipboard.writeText(fullLink); // Copy link to clipboard
    message.success({
      content: `Link copied`,
      key: "success",
    });
  };

  const handleFacebookShare = () => {
    const shareQuote = encodeURIComponent(text);
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=https://lookflock.com/#/ProductDetails/${text}&quote=${shareQuote}`
    );
  };

  const handleWhatsappShare = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(
        `${text}: ${listLink}`
      )}`
    );
  };
  const handleRevokeUser = async (index, Id) => {
    closeModal(false);
    const docRef = doc(
      db,
      "users",
      user?.uid,
      "shoppingList",
      selectedShopList?.id,
      "members",
      Id
    );
    const invitedListRef = doc(db, "users", Id, "invitedList", listId);
    const docSnap = await getDoc(docRef);
    try {
      if (docSnap.exists) {
        // Remove the friend from the array
        await deleteDoc(docRef);
        await deleteDoc(invitedListRef);
        const newfriendsData = friendsData.filter((friend) => friend.id !== Id);
        setFriendsData(newfriendsData);
        // console.log("friendsData", newfriendsData);
        toast.success("Access revoked successfully!", toastOptions);
      }
    } catch (error) {
      console.error(error);
      toast.error("Error removing user!", toastOptions);
    }
  };
  // console.log("listMembers !!", listMembers);

  const handleSearchBar = async (event) => {
    event.preventDefault();
    setSearchLoading(true);
    const itemsPerPage = 12;

    if (input.trim().length >= 3) {
      const searchQuery = `${input.trim()}`;
      // console.log("Search input: ", searchQuery);
      try {
        const data = await indexUsers.search(searchQuery, {
          length: itemsPerPage,
        });
        const uniqueUsers = new Set([...data.hits]);
        let updatedUsers = Array.from(uniqueUsers);
        // console.log("updatedUsers", updatedUsers);
        // Filter out the current user and existing members from the updatedUsers array
        updatedUsers = updatedUsers.filter(
          (updatedUser) =>
            updatedUser.objectID !== user?.uid &&
            !listMembers[updatedUser.objectID] &&
            updatedUser.objectUser.isVerified
        );

        // console.log(
        //   `Users in search on shopping list invite modal: `,
        //   updatedUsers
        // );
        if (updatedUsers.length === 0) {
          setIsFriendsDataEmpty(true);
        }
        // setSearchResults(updatedUsers);
        setFriendsData(updatedUsers);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setSearchLoading(false);
      }
    } else {
      console.log("Please enter at least 3 characters to search.");
    }
  };

  useEffect(() => {
    if (!listId) return;
    fetchShoppingListProducts();
  }, [data, listId]);

  // console.log("memebers1", members);

  const handleSelectFriend = (friendId, isSelected, friend) => {
    setMembers((prev) => {
      const updated = { ...prev };
      if (isSelected) {
        updated[friendId] = {
          role: updated[friendId]?.role || "commentor", // Default role
          displayName: friend.displayName, // Store displayName
        };
        setSelectedFriends((prevSelected) => [...prevSelected, friend]);
      } else {
        delete updated[friendId];
        setSelectedFriends((prevSelected) =>
          prevSelected.filter((f) => f.objectID !== friendId)
        );
      }
      return updated;
    });
  };

  // console.log("selected shopping List", selectedShopList);

  const handleInvite = async () => {
    if (!members || Object.keys(members).length === 0) {
      toast.warn("Please select members to invite.", toastOptions);
      return;
    }
    try {
      console.log(selectedShopList);
      setLoading(true);
      const friends = Object.keys(members);
      // Get member names for the channel message
      const memberNames = friends
        .map((friendId) => members[friendId].displayName)
        .join(", ");

      const usersToCreate = await Promise.all(
        friends.map(async (id) => {
          const docRef = doc(db, "users", id);
          const userData = await getDoc(docRef);
          const data = userData.data();
          console.log("data from invite people", data);
          console.log("friendid from invite people", id);

          return {
            id,
            name: data?.userName || "Unknown",
            image: data?.photo || "",
            email: data?.email,
          };
        })
      );

      await fetch(`${process.env.REACT_APP_API}/api/upsertUsers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ users: usersToCreate }),
      });

      await channel.addMembers(
        friends.map((friendId) => ({
          user_id: friendId,
          channel_role: "channel_moderator",
        })),
        {
          text: `${user?.displayName} added ${memberNames}`,
        }
      );
      // Add members to the channel with their names in the message
      // await channel.addMembers(friends, {
      //   text: `${user?.displayName} added ${memberNames}`
      // });
      const currentUserId = ownerId || user?.uid;
      const promises = Object.entries(members).map(
        async ([friendId, memberData]) => {
          const docRef = doc(
            db,
            "users",
            currentUserId,
            "shoppingList",
            selectedShopList?.id,
            "members",
            friendId
          );

          const invitedListRef = doc(
            db,
            "users",
            friendId,
            "invitedList",
            listId
          );

          return Promise.all([
            setDoc(
              docRef,
              { role: memberData.role, timestamp: serverTimestamp() },
              { merge: true }
            ),
            setDoc(
              invitedListRef,
              {
                role: memberData.role,
                timestamp: serverTimestamp(),
                userId: user?.uid,
              },
              { merge: true }
            ),
          ]).then(() => {
            // Add notification after both setDoc operations complete
            return addNotification({
              userId: friendId,
              id: user?.uid,
              type: "inviteOnList",
              by: "user",
              fields: {
                shopList: selectedShopList?.name,
                listId: listId,
              },
            });
          });
        }
      );

      await Promise.all(promises);

      if (content && content.trim()) {
        const messagePromises = Object.entries(members).map(
          ([friendId, memberData]) => {
            const msgToBeSent = {
              content: encryptChat(content), // Encrypt the note
              receiverId: friendId,
              senderId: user?.uid,
              type: "text",
            };
            return saveMessageToDB(msgToBeSent);
          }
        );

        await Promise.all(messagePromises);
      }

      // Change visibility to "Friends"
      if (ownerId === user?.uid) {
        const shoppingListRef = doc(
          db,
          "users",
          user?.uid,
          "shoppingList",
          selectedShopList?.id
        );

        await setDoc(
          shoppingListRef,
          {
            visibility: "Friends",
            ...selectedShopList,
          },
          { merge: true }
        );
      }

      toast.success("Invitations sent successfully.", toastOptions);
      handleClose();
    } catch (error) {
      console.error("Error sending invites:", error);
      toast.error(
        "Failed to send invitations. Please try again.",
        toastOptions
      );
      setLoading(false);
    }
  };

  // const handleInviteImmediately = async (friendId,displayName) => {
  //   try {
  //     let role = selectedRoles[friendId];
  //     console.log('handleInviteImmediately',role);

  //     if (!role) {
  //       role = 'commentor'
  //     }

  //     const docRef = doc(
  //       db,
  //       "users",
  //       user?.uid,
  //       "shoppingList",
  //       selectedShopList?.name,
  //       "members",
  //       friendId
  //     );

  //     const invitedListRef = doc(
  //       db,
  //       "users",
  //       friendId,
  //       "invitedList",
  //       listId
  //     );

  //     await Promise.all([
  //       setDoc(
  //         docRef,
  //         { role, timestamp: serverTimestamp() },
  //         { merge: true }
  //       ),
  //       setDoc(
  //         invitedListRef,
  //         {
  //           role,
  //           timestamp: serverTimestamp(),
  //           userId: user?.uid,
  //         },
  //         { merge: true }
  //       ),
  //     ]);

  //     toast.success(`${displayName} invited successfully`, toastOptions);
  //   } catch (error) {
  //     console.error("Error inviting friend:", error);
  //     toast.error("Failed to invite friend. Please try again.", toastOptions);
  //   }
  // };
  // console.log('friendData', friendsData);
  const handleClose = () => {
    setIsOpen(false);
    setIsFriendsDataEmpty(false);
    setFriendsData([]);
    setInput("");
    setContent("");
    setInviteOption("users");
    setError("");
    setEmailUsers([]);
    setEmailInputValue("");
    // setListMembers({});
    setSelectedFriends([]);
    setMembers({});
    setSearchLoading(false);
    setLoading(false);
  };
  return (
    <>
      {componentName === "ProfilePage" ? (
        <div onClick={() => handleButtonClick()}>
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.9166 12C16.1258 12 17.9166 10.433 17.9166 8.5C17.9166 6.567 16.1258 5 13.9166 5C11.7075 5 9.91663 6.567 9.91663 8.5C9.91663 10.433 11.7075 12 13.9166 12Z"
              stroke="#14191F"
              stroke-width="1.2"
            />
            <path
              d="M23.9166 12H21.9166M21.9166 12H19.9166M21.9166 12V10M21.9166 12V14"
              stroke="#14191F"
              stroke-width="1.2"
              stroke-linecap="round"
            />
            <path
              d="M20.9144 19.4444C20.9166 19.2985 20.9166 19.1502 20.9166 19C20.9166 16.7908 17.7826 15 13.9166 15C10.0506 15 6.91663 16.7908 6.91663 19C6.91663 21.2092 6.91663 23 13.9166 23C15.8688 23 17.2765 22.8607 18.2916 22.6119"
              stroke="#14191F"
              stroke-width="1.2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      ) : componentName === "ShoppingList" ? (
        <div
          style={{
            // width: "112px",
            // height: "40px",
            // gap: "10px",
            // borderRadius: "12px",
            cursor: "pointer",
          }}
          // className="d-flex align-items-center justify-content-center primaryButton"
          onClick={() => {
            handleButtonClick();
          }}
        >
          <svg
            style={{
              width: isSmallScreen ? "22px" : "26px",
              height: isSmallScreen ? "22px" : "26px",
            }}
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.8333 11.3332C13.2266 11.3332 15.1667 9.39307 15.1667 6.99984C15.1667 4.6066 13.2266 2.6665 10.8333 2.6665C8.4401 2.6665 6.5 4.6066 6.5 6.99984C6.5 9.39307 8.4401 11.3332 10.8333 11.3332Z"
              stroke="#14191F"
            />
            <path
              d="M22.7498 11.3332H20.5832M20.5832 11.3332H18.4165M20.5832 11.3332V9.1665M20.5832 11.3332V13.4998"
              stroke="#14191F"
              stroke-linecap="round"
            />
            <path
              d="M19.4971 20.0002C19.4998 19.8223 19.4998 19.6416 19.4998 19.4585C19.4998 16.7661 15.6197 14.5835 10.8332 14.5835C6.0467 14.5835 2.1665 16.7661 2.1665 19.4585C2.1665 22.1509 2.1665 24.3335 10.8332 24.3335C13.2501 24.3335 14.993 24.1637 16.2498 23.8605"
              stroke="#14191F"
              stroke-linecap="round"
            />
          </svg>
        </div>
      ) : componentName === "shopListMore" ? (
        <></>
      ) : (
        <li
          className="nav-item list-unstyled"
          onClick={() => handleButtonClick()}
        >
          <Link className="btn btn-sm btn-primary p-2 py-1 rounded-4">
            {/* <PersonPlusFill className="fs-5" /> Invite */}
            <i className="fas fa-plus fs-6"></i>
          </Link>
        </li>
      )}
      <style jsx>
        {`
          .invitePeopleModal .modal-content {
            border-radius: 20px !important;
            width: 36rem;
            overflow: hidden;
            max-height: 660px;
          }

          .invitePeopleModal .modal-dialog {
            max-width: 36rem;
            margin: 1rem auto; /* Add some margin */
          }
        `}
      </style>
      {isSmallScreen ? (
        <BottomTray
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          text={"Invite Collaborators"}
          onClose={handleClose}
        >
          <InviteCollaborators
            inviteOption={inviteOption}
            setInviteOption={setInviteOption}
            onEmailFinish={onEmailFinish}
            emailUsers={emailUsers}
            removeEmail={removeEmail}
            emailInputValue={emailInputValue}
            handleEmailChange={handleEmailChange}
            handleKeyDown={handleKeyDown}
            content={content}
            setContent={setContent}
            handleSearchBar={handleSearchBar}
            input={input}
            setInput={setInput}
            setIsFriendsDataEmpty={setIsFriendsDataEmpty}
            searchLoading={searchLoading}
            selectedFriends={selectedFriends}
            handleSelectFriend={handleSelectFriend}
            friendsData={friendsData}
            isFriendsDataEmpty={isFriendsDataEmpty}
            loading={loading}
            handleCopyLink={handleCopyLink}
            handleFacebookShare={handleFacebookShare}
            handleWhatsappShare={handleWhatsappShare}
            handleInvite={handleInvite}
            Error={Error}
            members={members}
          />
        </BottomTray>
      ) : (
        <>
          <Modal
            show={isOpen}
            onHide={handleClose}
            centered
            className="invitePeopleModal"
          >
            <Modal.Body style={{ padding: isSmallScreen ? "20px" : "40px" }}>
              <div className="d-flex flex-column" style={{ gap: "24px" }}>
                <div className="d-flex w-100 justify-content-between align-items-center">
                  <div
                    style={{
                      fontFamily: "Inter",
                      color: "#101828",
                      fontWeight: "600",
                      fontSize: isSmallScreen ? "18px" : "24px",
                      lineHeight: isSmallScreen ? "18px" : "24px",
                      letterSpacing: "0%",
                    }}
                  >
                    Invite Collaborators
                  </div>
                  <button
                    type="button"
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "27px",
                      height: "27px",
                      background: "#FFFFFF",
                      border: "1px solid #FF3B30",
                      boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                      borderRadius: "25px",
                      flex: "none",
                      order: "1",
                      flexGrow: "0",
                    }}
                    onClick={handleClose}
                  >
                    <svg
                      style={{ width: "11px" }}
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13 1L1 13M1 1L13 13"
                        stroke="#FF3B30"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                {/* Tabs for Users/Brands */}
                <div className="d-flex flex-column " style={{ gap: "12px" }}>
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "60px" }}
                  >
                    <div
                      onClick={() => setInviteOption("users")}
                      className="linkStyle"
                      style={{
                        borderBottom:
                          inviteOption === "users"
                            ? `1px solid rgb(0, 95, 218)`
                            : "",
                        color: inviteOption === "users" ? "#005FDA" : "#667085",
                        fontSize: "18px",
                        fontWeight: 500,
                        margin: 0,
                        cursor: "pointer",
                      }}
                    >
                      Users
                    </div>
                    <div
                      onClick={() => setInviteOption("email")}
                      className="linkStyle"
                      style={{
                        borderBottom:
                          inviteOption === "email"
                            ? `1px solid rgb(0, 95, 218)`
                            : "",
                        color: inviteOption === "email" ? "#005FDA" : "#667085",
                        fontSize: "18px",
                        fontWeight: 500,
                        margin: 0,
                        cursor: "pointer",
                      }}
                    >
                      Email
                    </div>
                  </div>
                  <div className="d-flex flex-column " style={{ gap: "24px" }}>
                    {inviteOption === "email" ? (
                      <Form
                        className="d-flex flex-column gap-1"
                        onSubmit={async (e) => {
                          e.preventDefault();
                          onEmailFinish(emailUsers);
                        }}
                      >
                        <div>
                          {emailUsers.length > 0 && (
                            <div
                              className="d-flex align-items-center gap-2 mb-2"
                              style={{
                                overflowX: "auto",
                                scrollbarWidth: "thin",
                                paddingBottom: "4px",
                              }}
                            >
                              {emailUsers.map((email, index) => (
                                <Button
                                  key={index}
                                  size="sm"
                                  variant="primary-soft"
                                  className="d-flex align-items-center"
                                >
                                  {email}
                                  <CloseButton
                                    className="ms-2"
                                    onClick={() => removeEmail(index)}
                                  />
                                </Button>
                              ))}
                            </div>
                          )}
                          <div className="d-flex gap-2 align-items-center">
                            <Form.Control
                              type="text"
                              placeholder="email@example.com"
                              className="rounded-2 h-50"
                              value={emailInputValue}
                              onChange={handleEmailChange}
                              onKeyDown={handleKeyDown}
                            />
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip>
                                  Press enter after typing each email address.
                                  You can add up to 10 email addresses.
                                </Tooltip>
                              }
                            >
                              <i
                                style={{ cursor: "pointer", color: "#0f6fec" }}
                                className="bi bi-info-circle"
                              ></i>
                            </OverlayTrigger>
                          </div>
                        </div>
                        <span className="text-danger">{Error}</span>
                        <div className="mt-0">
                          <textarea
                            className="form-control rounded-2"
                            rows="2"
                            placeholder="Add a note or message (Optional)"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            maxLength={300}
                          />
                          <small>Character limit: 300</small>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                          <Button
                            className="rounded-3 w-100"
                            type="submit"
                            variant="primary"
                            disabled={
                              emailUsers.length === 0 &&
                              emailInputValue.length === 0
                            }
                          >
                            <span>Send Invite</span>
                          </Button>
                        </div>
                      </Form>
                    ) : (
                      <form onSubmit={(event) => handleSearchBar(event)}>
                        <div className="input-group gap-2">
                          <input
                            type="text"
                            className="form-control rounded-3"
                            placeholder="Search by name or email"
                            value={input}
                            onChange={(e) => {
                              setInput(e.target.value);
                              setIsFriendsDataEmpty(false);
                            }}
                            required
                          />
                          <button
                            style={{ width: "6rem" }}
                            className="btn btn-primary rounded-3"
                            type="submit"
                            disabled={input.length < 3}
                          >
                            {searchLoading ? (
                              <LoadingSpinner
                                height="10px"
                                spinnerSize="20px"
                              />
                            ) : (
                              "Search"
                            )}
                          </button>
                        </div>
                        {selectedFriends.length > 0 && (
                          <div
                            className="alphabet-list navbar thinScrollBar py-2"
                            style={{ overflowX: "auto" }}
                          >
                            <ul className="nav d-flex flex-row flex-nowrap list-unstyled gap-2 pt-1 ">
                              {selectedFriends.map((friend) => {
                                return (
                                  <li
                                    key={friend.objectID}
                                    className="btn rounded-2 btn-sm btn-primary-soft  d-flex gap-2 align-items-center ps-1 py-1"
                                    onClick={() =>
                                      handleSelectFriend(
                                        friend.objectID,
                                        false,
                                        friend
                                      )
                                    }
                                  >
                                    <X className="fs-5 " />

                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {friend.displayName}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                        {/* <hr /> */}
                        {friendsData?.length > 0 && (
                          <>
                            <div
                              className="d-flex flex-column mt-2"
                              style={{ maxHeight: "12rem", overflowY: "auto" }}
                            >
                              {friendsData?.map((friend, index) => {
                                return (
                                  <div
                                    key={friend.id}
                                    className="d-flex justify-content-between align-items-center w-100 my-1"
                                  >
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ gap: "6px" }}
                                    >
                                      <input
                                        name="members"
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={!!members[friend.objectID]}
                                        onChange={(e) =>
                                          handleSelectFriend(
                                            friend.objectID,
                                            e.target.checked,
                                            friend
                                          )
                                        }
                                      />
                                      <img
                                        src={
                                          friend?.objectUser?.photo ||
                                          `https://ui-avatars.com/api/?name=${friend?.objectUser?.userName[0]?.toUpperCase()}`
                                        }
                                        style={{
                                          borderRadius: "8px",
                                          width: isSmallScreen
                                            ? "40px"
                                            : "48px",
                                          height: isSmallScreen
                                            ? "40px"
                                            : "48px",
                                          objectFit: "cover",
                                        }}
                                        loading="lazy"
                                        alt=""
                                      />
                                      <div
                                        className="d-flex flex-column"
                                        style={{ gap: "2px" }}
                                      >
                                        <div
                                          style={{
                                            fontFamily: "Inter",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            lineHeight: "100%",
                                            letterSpacing: "0%",
                                            color: "black",
                                          }}
                                        >
                                          {friend?.displayName}
                                        </div>
                                        <CheckStatus
                                          myUid={user?.uid}
                                          yourEmail={friend?.email}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                        {isFriendsDataEmpty && (
                          <div className="text-center pt-3">
                            <div className="h5 mb-0">No users found</div>
                          </div>
                        )}
                      </form>
                    )}
                    {friendsData?.length > 0 &&
                      inviteOption === "users" &&
                      (loading ? (
                        <button
                          type="button"
                          className="btn btn-primary w-100 rounded-3"
                        >
                          <LoadingSpinner spinnerSize="1rem" height="1.5rem" />
                        </button>
                      ) : (
                        <button
                          onClick={() => handleInvite()}
                          type="button"
                          className="btn btn-primary w-100 rounded-3"
                        >
                          Send Invite
                        </button>
                      ))}
                    <div className="d-flex flex-column" style={{ gap: "4px" }}>
                      <div
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "16px",
                          lineHeight: "100%",
                          letterSpacing: "0%",
                          color: "black",
                        }}
                      >
                        Share By
                      </div>
                      <div
                        className="d-flex justify-content-center"
                        style={{ gap: "16px" }}
                      >
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={handleFacebookShare}
                        >
                          <Facebook />
                        </span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={handleWhatsappShare}
                        >
                          <WhatsApp />
                        </span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={handleCopyLink}
                        >
                          <CopyLink />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={showRemoveModal}
            onHide={() => {
              setShowRemoveModal(false);
              setIsFriendsDataEmpty(false);
            }}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Revoke</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <i
                style={{ fontSize: "4.5rem" }}
                className="text-body bi bi-exclamation-triangle"
              ></i>
              <div className="mt-4 fs-5 text-body">
                Are you sure you want to revoke access from {DATA.displayName}?
              </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
              <Button
                variant="secondary-soft"
                className="w-25 mx-1"
                onClick={() => {
                  setDATA({
                    friendId: "",
                    displayName: "",
                  });
                  setShowRemoveModal(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="w-25 mx-1"
                onClick={() => {
                  // console.log("data.friendId", DATA.friendId);
                  handleRevokeUser("", DATA.friendId);
                  setDATA({
                    friendId: "",
                    displayName: "",
                  });
                  setShowRemoveModal(false);
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
}

export default InvitePeople;
